import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { type PropType, ref, watch } from "vue";
import { patchMenuItems, type MenuItem } from "./menu-item";
import Items from "./items.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  props: {
    menuItems: {
        type: Array as PropType<MenuItem[]>,
        required: true,
    },
    mobile: Boolean,
},
  setup(__props) {

const props = __props;

const patchedMenuItems = ref(patchMenuItems(props.menuItems));

watch(
    () => props.menuItems,
    (newValue) => {
        patchedMenuItems.value = patchMenuItems(newValue);
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.mobile ? _ctx.$style['mobile-menu'] : _ctx.$style['desktop-menu'])
  }, [
    _createVNode(Items, {
      mobile: __props.mobile,
      "menu-items": patchedMenuItems.value,
      "parent-last": "",
      level: 0
    }, null, 8 /* PROPS */, ["mobile", "menu-items"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['after-menu-container'])
    }, [
      _renderSlot(_ctx.$slots, "after-menu")
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})